import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Inflow from '../Cashflow/InflowPayments';
import Outflow from '../Cashflow/OutflowPayments';


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ px: 0, py: 2 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
   
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default function CashFlowTabs() {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
  };

    return (
      <Box sx={{ width: '100%', marginTop:'-10px', marginRight:'-65px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', marginRight:'5px'}}>
          <Tabs value={value} onChange={handleChange} aria-label="Payments">
            <Tab label="Payment In" {...a11yProps(0)} />
            <Tab label="Payment Out" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
            <Inflow />
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Outflow />
        </TabPanel>
      </Box>
    );
  }
